import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_FULL } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.DEVELOPER)({
    component: DeveloperLayout,
    staticData: {
        config: {
            title: "developer",
        },
        permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
    },
});

function DeveloperLayout() {
    return <Outlet />;
}
